import { render, staticRenderFns } from "./PropertyEditor.yaml?vue&type=template&id=47a68b94&component"
import script from "./PropertyEditor.yaml?vue&type=script&lang=ts&component"
export * from "./PropertyEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports